import { BrowserRouter, useRoutes } from 'react-router-dom';
import './App.css';
import './styles/GridStyles.css';
import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import routes from './routes';



const AppRoutes = () => {
    return useRoutes(routes);
};

function App() {
    return (
        <BrowserRouter
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <AppRoutes />
        </BrowserRouter>
    );
}

export default App;
